import { render } from "./TourGuidesView.vue?vue&type=template&id=2b5198b7"
import script from "./TourGuidesView.vue?vue&type=script&lang=js"
export * from "./TourGuidesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__